import { zonedTimeToUtc } from 'date-fns-tz';

export const parseUtc = (sourceUtc: string) => zonedTimeToUtc(sourceUtc, 'UTC');
export const now = () => zonedTimeToUtc(Date.now(), 'UTC');
